import {
  PAYPAL_TX_LOOKUP_REQUEST,
  PAYPAL_TX_LOOKUP_SUCCESS,
  PAYPAL_TX_LOOKUP_ERROR,
  PAYPAL_TX_LOOKUP_RESET,
} from "./ActionType";

const initialState = {
  isRequest: false,
  isSuccess: false,
  isError: false,
  data: null,
  error: null,
};

const paypalTxLookupReducer = (state = initialState, action) => {
  switch (action.type) {
    case PAYPAL_TX_LOOKUP_REQUEST:
      return { ...initialState, isRequest: true };
    case PAYPAL_TX_LOOKUP_SUCCESS:
      return { ...initialState, isSuccess: true, data: action.payload };
    case PAYPAL_TX_LOOKUP_ERROR:
      return { ...initialState, isError: true, error: action.payload };
    case PAYPAL_TX_LOOKUP_RESET:
      return initialState;
    default:
      return state;
  }
};

export default paypalTxLookupReducer;
